const dateFormatCustom = {}

dateFormatCustom.install = function(Vue) {
  Vue.filter('dateFormatString', val => {
    if (val && val.split('-').length == 3) {
      let values = val.split('-')
      return `${values[2]}-${values[1]}-${values[0]}`
    } else {
      return val
    }
  })
}

export default dateFormatCustom
